import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import "./Splash.css";
import LoaderLogo from "../../components/Loader/LoaderLogo.js";

const Splash = (props) => {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setRedirect(true), 5500);
    return () => clearTimeout(id);
  }, []);

  return redirect ? (
    <Redirect to="/home" />
  ) : (
    <div className="logo_wrapper">
      <div className="screen" style={{ backgroundColor: props.theme.splashBg }}>
        <LoaderLogo id="logo" theme={props.theme} />
      </div>
    </div>
  );
};

export default Splash;
